module.exports = __webpack_public_path__ + "img/breast-screening.9e5d5a7b.jpg";